// Deux peaux, un seul jeu de règles (voir styles/base.css).
//
//   instrument — la maquette V5 : blanc, filets d'1 px, angles vifs, cobalt.
//   registre   — le langage de SotCP V3 : papier réglé, encre vert-noir,
//                vert banquier, rouge sceau, ambre, kraft, angles arrondis,
//                Archivo + IBM Plex Mono.
//
// Le choix vit sur <html data-skin> et dans le stockage local : il suit le
// poste, pas le compte. Deux personnes sur deux PC peuvent ne pas voir la même
// chose, et c'est très bien — c'est une préférence d'affichage, pas une donnée.

export type Peau = 'registre' | 'instrument'

const CLE = 'flashcp-peau'
const DEFAUT: Peau = 'registre'

export function peauCourante(): Peau {
  const v = localStorage.getItem(CLE)
  return v === 'instrument' || v === 'registre' ? v : DEFAUT
}

export function appliquerPeau(p: Peau): void {
  document.documentElement.setAttribute('data-skin', p)
  localStorage.setItem(CLE, p)
}

export function basculerPeau(): Peau {
  const suivante: Peau = peauCourante() === 'registre' ? 'instrument' : 'registre'
  appliquerPeau(suivante)
  return suivante
}

/** À appeler avant le premier rendu — sinon la page clignote au chargement. */
export function initPeau(): void {
  appliquerPeau(peauCourante())
}
